var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Heart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 322",
    opacity: 0.25,
    d: "M25.0332 44.6729L23.622 43.231C16.7274 36.1865 16.7274 24.7652 23.622 17.7208L29.1582 12.0642C32.9952 8.1438 39.2162 8.1438 43.0532 12.0642C46.8901 15.9846 46.8901 22.3408 43.0532 26.2612L25.0332 44.6729Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 323",
    d: "M25.0938 44.6729L26.505 43.231C33.3995 36.1865 33.3995 24.7652 26.505 17.7208L20.9687 12.0642C17.1317 8.1438 10.9108 8.1438 7.07379 12.0642C3.23682 15.9846 3.23682 22.3408 7.07379 26.2612L25.0938 44.6729Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIcon);
export default __webpack_public_path__ + "static/media/HeartIcon.e110708390af891c14f498dbf4c964c1.svg";
export { ForwardRef as ReactComponent };